import { localize } from 'vee-validate'

const loadValidatorLocale = (code) => {
  return import(`@/lang/validation/${code}.json`).then((locale) => {
    localize(code, locale)
  })
}

export default loadValidatorLocale
